module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mega-menu/menu-style1/menu-style1.component.scss
// module id = ./src/app/mega-menu/menu-style1/menu-style1.component.scss
// module chunks = main